
import React, { useRef } from 'react';
import Box from '@mui/material/Box';


interface IProps {
  setHeight: (value: number) => void;
  sx: any;
}

const SliderBar = ({ setHeight, sx }: IProps) => {
  const elementRef = useRef<HTMLDivElement>(null);

  const startResizing = (mouseDownEvent: any) => {
    const startY = mouseDownEvent.clientY;
    const startHeight =
      elementRef.current?.parentElement?.getBoundingClientRect().height || 0;
    const previewHeight =
      elementRef.current?.parentElement?.firstElementChild?.getBoundingClientRect()
        .height || 0;

    const doResize = (mouseMoveEvent: MouseEvent) => {
      const currentY = mouseMoveEvent.clientY;
      const deltaY = currentY - startY;
      setHeight(Math.round(((previewHeight + deltaY) / startHeight) * 100));
    };

    const stopResizing = () => {
      document.removeEventListener('mousemove', doResize);
      document.removeEventListener('mouseup', stopResizing);
    };

    document.addEventListener('mousemove', doResize);
    document.addEventListener('mouseup', stopResizing);
  };

  return (
    <Box
      sx={sx}
      ref={elementRef}
      onMouseDown={startResizing}
      style={{
        borderTop: !sx ? 'solid 1px #ccc' : '0',
        width: '80%',
        margin: '0 auto',
        height: '1rem',
        zIndex: 20,
        transform: !sx ? 'translateY(.5rem)' : 'translateY(3.5rem)',
        cursor: 'ns-resize',
        background: 'transparent',
      }}
    />
  );
};

export default SliderBar;